import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-min-max-percent-game',
  templateUrl: './min-max-percent-game.component.html',
  styleUrls: ['./min-max-percent-game.component.scss'],
})
export class MinMaxPercentGameComponent implements OnInit {
  @Input() min: number = 0;
  @Input() max: number = 0;
  @Input() avg: number = 0;
  constructor() {}

  ngOnInit() {}
}
